import { AuthProvider } from '@sdk/authentication/AuthContext';
import { PersonaCollectionContext } from '@sdk/personaCollection/PersonaCollectionContext';
import { ClientFlagsProvider } from '@sdk/session/ClientFlagsContext';

import ActivityLog from '@web/shifts/ActivityLog/ActivityLog';
import { ActivityLogAnnouncement } from '@web/shifts/ActivityLog/ActivityLogAnnouncement/ActivityLogAnnouncement';

const ActivityLogAngular = ({
  open,
  close,
  onItemClick,
  currentUser,
  isMySchedule,
  isMyLocations,
  isAllLocations,
  isExperimental,
  reloadAt,
  scheduleFilters,
  PersonaCollection,
  DayPartsService,
  dateRange,
  onActivityLogAnnouncementTryNowClicked,
}) => {
  if (!currentUser) {
    return null;
  }

  return (
    <AuthProvider currentUser={currentUser}>
      <PersonaCollectionContext.Provider value={PersonaCollection}>
        <ClientFlagsProvider>
          <ActivityLog
            open={open}
            close={close}
            onItemClick={onItemClick}
            isMySchedule={isMySchedule}
            isMyLocations={isMyLocations}
            isAllLocations={isAllLocations}
            isExperimental={isExperimental}
            reloadAt={reloadAt}
            scheduleFilters={scheduleFilters}
            dayParts={DayPartsService.dayParts}
            dateRange={dateRange}
          />
          <ActivityLogAnnouncement onTryNowClicked={onActivityLogAnnouncementTryNowClicked} />
        </ClientFlagsProvider>
      </PersonaCollectionContext.Provider>
    </AuthProvider>
  );
};

export default {
  ReactComponent: ActivityLogAngular,
  bindings: {
    open: '<',
    close: '&',
    onItemClick: '<',
    currentUser: '<',
    isMySchedule: '<',
    isMyLocations: '<',
    isAllLocations: '<',
    isExperimental: '<',
    reloadAt: '<?',
    scheduleFilters: '<',
    dateRange: '<',
    onActivityLogAnnouncementTryNowClicked: '&',
  },
  dependencies: ['PersonaCollection', 'DayPartsService'],
};
